import { render } from "./importer.vue?vue&type=template&id=5c6cd216"
import script from "./importer.vue?vue&type=script&lang=js"
export * from "./importer.vue?vue&type=script&lang=js"

import exportComponent from "D:\\AICodeSpace\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__